import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-staff-kpi-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, TranslateModule],
  templateUrl: './staff-kpi-card.component.html',
  styleUrl: './staff-kpi-card.component.scss',
})
export class StaffKpiCardComponent {
  readonly labelKey = input.required<string>();
  readonly value = input.required<string | number>();
  readonly hintKey = input<string | null>(null);
  readonly hintParams = input<Record<string, string | number>>({});
  readonly highlight = input(false);
  readonly clickable = input(true);
  readonly loading = input(false);
  /** Visual grouping on staff home finance panels. */
  readonly tone = input<'default' | 'debtor' | 'wallet'>('default');
  readonly size = input<'default' | 'prominent'>('default');
  readonly align = input<'center' | 'start'>('center');
  /** Show metric title above the value for faster scanning. */
  readonly labelFirst = input(false);
  readonly deltaLabel = input<string | null>(null);
  readonly deltaTone = input<'up' | 'down' | 'flat' | null>(null);
  readonly metricKind = input<'period' | 'snapshot' | null>(null);

  readonly cardClick = output<void>();

  protected onClick(): void {
    if (!this.clickable() || this.loading()) {
      return;
    }

    this.cardClick.emit();
  }
}
